var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"drops",staticClass:"app-drops-view"},_vm._l((_vm.drops),function(item){return _c('div',{key:item.id,staticClass:"img",on:{"click":function($event){return _vm.editDrop(item)}}},[_c('img',{attrs:{"src":item.url,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }